import { Button } from "@global/components";
import { styled } from "@mui/material";

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiTypography-root': {
    fontWeight: theme.typography.fontWeightBold
  }
}))